<div class="container p-4 p-md-5 recover-pass-screen">
    <div class="d-flex justify-content-end">
        <app-button id="back-desktop" [onlyIcon]="true"
            [isIcon]="true" [left]="true"
            [iconName]="'bi bi-arrow-left'"
            [buttonOptions]="buttonOptions"
            (buttonClick)="back()">
        </app-button>
    </div>
    <div class="logo-sou-mais-fc-page p-3 text-center">
        <img [src]="logoUrl" alt="Logo">
    </div>
    <div class="recoverpass-main-title px-5 my-4 text-center">
        {{pageTitle}}
    </div>
    <div class="row justify-content-center">
      @if (recoverStep === 'EMAIL') {
        <div class="col-md-6">
            <form [formGroup]="recoverPassFormGroup" >
                <app-input class="col-md-6" [id]="'emailInputId'" [label]="'Email'" [type]="InputType.EMAIL"
                    [placeholder]="'Insira seu email'" formControlName="emailControl">
                </app-input>
            </form>
            <div class="text-center my-5" id="btn-recover-pass">
                <app-button class="mx-2 my-1" [disabled]="!recoverPassFormGroup.valid" [buttonOptions]="recoverPassBtn"
                    (buttonClick)="recoverPassword()"></app-button>
            </div>
        </div>
      } @else if (recoverStep === 'CODE') {
        <div class="col-md-6">
          <form [formGroup]="passwordFormGroup">
            <app-input label="Código recebido no e-mail" formControlName="code"  [type]="InputType.NUMBER"></app-input>

            <div class="d-md-flex justify-content-center gap-3 d-sm-block text-center">
              <app-button class="mb-3 mb-md-0" buttonText="Validar código" [buttonOptions]="codeBtn" (buttonClick)="validateCode()">
              </app-button>

              <app-button buttonText="Reenviar código" [buttonOptions]="resendBtn" (buttonClick)="recoverPassword()">
              </app-button>
            </div>

          </form>
        </div>
      } @else if (recoverStep === 'NEW_PASSWORD') {
        <div class="col-md-6">
          <form [formGroup]="passwordFormGroup">
            <app-input label="Nova senha" [type]="InputType.PASSWORD" formControlName="newPassword"></app-input>

            <app-button buttonText="Alterar senha" [buttonOptions]="resetBtn" (buttonClick)="changePassword()"></app-button>
          </form>
        </div>
      }

    </div>
</div>

<app-modal [modalTitle]="'Redefinir senha'" [modalId]="modalId" [modalBodyMessage]="modalBodyMessage"
    [showCloseBtn]="false" (confirmActionChange)="onModalConfirm()"></app-modal>
